/*
  cart-drawer-custom.js
  ---------------------------------------------------------------------------
  Ported 1:1 (behaviour) from the source theme's own asset of the same name.
  It is NOT part of stock Dawn 16.

  What it does: a delegated click handler on `document` that drives the two
  custom controls of the custom cart drawer markup (the ".mcd-*" classes,
  styled by component-cart-drawer-custom.css):

    [data-mcd-remove][data-key]                  -> removes that cart line
    [data-mcd-tier][data-key][data-to][data-plan] -> swaps that cart line for
                                                     another variant ("bundle
                                                     upgrade"): add the target
                                                     variant, then remove the
                                                     old line.

  Both go through Shopify's Section Rendering API (`sections=cart-drawer,
  cart-icon-bubble`) and re-render `#CartDrawer` and `#cart-icon-bubble` from
  the response instead of reloading the page. While a request is in flight the
  row gets `data-busy="1"` and a module-level `mutating` flag blocks a second
  mutation. On failure the drawer's `.mcd-err` element is revealed with a
  message and the row is re-enabled.

  The source ships this minified; it has been expanded for readability without
  changing any behaviour, selector, string or request shape.

  Loaded from layout/theme.liquid and layout/theme-lp.liquid inside the
  `settings.cart_type == 'drawer'` block, right after cart-drawer.js, exactly
  where the source loads it.
*/
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var mutating = false;

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function showError(msg) {
    var el = document.querySelector('#CartDrawer .mcd-err');
    if (el) {
      el.textContent = msg;
      el.hidden = false;
    }
  }

  function busy(key, state) {
    if (!key) return;
    var rows = document.querySelectorAll('#CartDrawer .mcd-line');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-key') !== key) continue;
      if (state) {
        rows[i].setAttribute('data-busy', '1');
      } else {
        rows[i].removeAttribute('data-busy');
      }
    }
  }

  function innerHTMLFrom(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function applySections(state) {
    var sections = state && state.sections;
    if (!sections) return;

    var drawerHTML = sections['cart-drawer'];
    if (drawerHTML) {
      var target = document.querySelector('#CartDrawer');
      var markup = innerHTMLFrom(drawerHTML, '#CartDrawer');
      if (target && markup !== null) target.innerHTML = markup;
    }

    var bubbleHTML = sections['cart-icon-bubble'];
    if (bubbleHTML) {
      var bubble = document.getElementById('cart-icon-bubble');
      var bubbleMarkup = innerHTMLFrom(bubbleHTML, '.shopify-section');
      if (bubble && bubbleMarkup !== null) bubble.innerHTML = bubbleMarkup;
    }

    var drawer = drawerEl();
    if (drawer) {
      if (state.item_count === 0) {
        drawer.classList.add('is-empty');
      } else {
        drawer.classList.remove('is-empty');
      }
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof drawer.close == 'function') {
        overlay.addEventListener('click', drawer.close.bind(drawer));
      }
    }
  }

  function postJSON(url, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'cart error');
        return data;
      });
    });
  }

  function removeLine(key, btn) {
    if (!key || mutating) return;
    mutating = true;
    busy(key, true);
    if (btn) btn.disabled = true;

    var updates = {};
    updates[key] = 0;

    postJSON('/cart/update.js', { updates: updates })
      .then(applySections)
      .catch(function () {
        busy(key, false);
        if (btn) btn.disabled = false;
        showError("That didn't go through — please try again.");
      })
      .then(function () {
        mutating = false;
      });
  }

  // Kaching koppelt het gratis e-book aan zijn eigen bundeleigenschap. Onze tierwissel maakt een regel
  // zonder die eigenschap, waarop Kaching het geschenk laat vallen. Ontbreekt het na een wissel, dan
  // zetten we het er zelf weer in - het kost niets en staat toch niet in de lade.
  function ensureGift(state) {
    var drawer = document.querySelector('#CartDrawer');
    var giftId = drawer && drawer.getAttribute('data-mcd-gift-variant');
    if (!giftId) return state;

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var heeft = (cart.items || []).some(function (i) {
          return String(i.variant_id) === String(giftId);
        });
        if (heeft || !cart.items || cart.items.length === 0) return state;
        // Bewust zonder secties: het geschenk is verborgen, dus hertekenen zou alleen maar flikkeren.
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: giftId, quantity: 1 }),
        });
      })
      .catch(function () { return state; });
  }

  function setTier(key, toVariantId, plan, qty, btn) {
    if (!key || !toVariantId || mutating) return;
    mutating = true;
    // Blijft een verzoek hangen, dan zou deze vlag elke volgende klik blokkeren en lijkt de knop dood.
    // Na tien seconden geven we hem hoe dan ook vrij.
    setTimeout(function () { mutating = false; }, 10000);
    busy(key, true);
    if (btn) btn.disabled = true;

    // Een tier is een aantal pakken, geen los stuk. Zonder dit aantal belandt er 1 pak in de cart
    // en klopt de bundel niet meer, waarna Kaching de wijziging terugdraait.
    var n = parseInt(qty, 10);
    if (!(n > 0)) n = 1;
    var addBody = { id: toVariantId, quantity: n };
    if (plan) addBody.selling_plan = plan;

    // Terugval: accepteert de doelvariant het abonnementsplan toch niet, dan antwoordt Shopify met
    // 422 "Cannot apply selling plan to variant". Beter de bundel zonder plan wisselen dan de klant
    // met een onveranderde cart laten zitten.
    function addTarget() {
      return postJSON('/cart/add.js', addBody).catch(function (err) {
        if (addBody.selling_plan && /selling plan/i.test(err && err.message)) {
          delete addBody.selling_plan;
          return postJSON('/cart/add.js', addBody);
        }
        throw err;
      });
    }

    // Snelle route: alles in een verzoek. /cart/update.js neemt regelsleutels en variant-id's door
    // elkaar, en zet een variant die nog niet in de cart zit er gewoon bij.
    function swapInOneCall() {
      var updates = {};
      updates[key] = 0;
      updates[toVariantId] = n;

      var drawer = document.querySelector('#CartDrawer');
      var giftId = drawer && drawer.getAttribute('data-mcd-gift-variant');
      if (giftId && String(giftId) !== String(toVariantId)) {
        // Kaching laat zijn geschenk vallen zodra de bundelregel verdwijnt; meteen weer meesturen
        // scheelt een extra ronde en de klant merkt er niets van.
        updates[giftId] = 1;
      }
      return postJSON('/cart/update.js', { updates: updates });
    }

    // Trage route, alleen nodig als er een geldig abonnementsplan meemoet: `updates` kent geen
    // selling_plan, dus dan eerst toevoegen en daarna de oude regel opruimen.
    function swapWithPlan() {
      return addTarget()
        .then(function () {
          var updates = {};
          updates[key] = 0;
          return postJSON('/cart/update.js', { updates: updates });
        })
        .then(ensureGift);
    }

    var run = plan ? swapWithPlan() : swapInOneCall();

    run
      .then(applySections)
      .then(function (state) {
        // Kaching haalt zijn geschenk pas weg nadat het gemerkt heeft dat de bundelregel zijn eigen
        // eigenschap kwijt is - dat gebeurt na ons verzoek. Daarom nog een keer kijken zodra het stof is
        // neergedaald. Het geschenk staat toch niet in de lade, dus dit hoeft de klant niet af te wachten.
        setTimeout(ensureGift, 1500);
        return state;
      })
      .catch(function () {
        busy(key, false);
        if (btn) btn.disabled = false;
        showError("We couldn't change the bundle. Your cart is unchanged.");
      })
      .then(function () {
        mutating = false;
      });
  }

  // Capture-fase, niet bubble. In de lade draaien ook Dawn's eigen cart-drawer en de scripts van
  // Kaching; roept een van die twee stopPropagation() aan op een klik binnen de lade, dan bereikt de
  // klik een bubble-listener op document nooit en gebeurt er zichtbaar niets. Capture loopt voor die
  // handlers uit, dus de knoppen blijven werken ongeacht wat er verder in de lade meeluistert.
  var lastFire = 0;

  function activate(event, forced) {
    var now = Date.now();
    if (now - lastFire < 700) return;

    var start = forced || (event && event.target);
    if (!start || typeof start.closest !== 'function') return;

    var remove = start.closest('[data-mcd-remove]');
    if (remove) {
      lastFire = now;
      if (event && event.cancelable) event.preventDefault();
      removeLine(remove.getAttribute('data-key'), remove);
      return;
    }

    var tier = start.closest('[data-mcd-tier]');
    if (tier && !tier.hasAttribute('disabled')) {
      lastFire = now;
      if (event && event.cancelable) event.preventDefault();
      setTier(
        tier.getAttribute('data-key'),
        tier.getAttribute('data-to'),
        tier.getAttribute('data-plan'),
        tier.getAttribute('data-qty'),
        tier
      );
    }
  }

  // Vangnet 1: op document, in de capture-fase. Loopt voor elke handler in de lade uit, dus een
  // stopPropagation daarbinnen kan de knop niet meer doodleggen.
  document.addEventListener('click', activate, true);

  // Vangnet 2: rechtstreeks op de knoppen. Werkt ook als iets over de knop heen ligt of als een ander
  // script het click-event onderweg tegenhoudt. touchend erbij, want op touch ontstaat er soms helemaal
  // geen click.
  function bindDirect() {
    var els = document.querySelectorAll('[data-mcd-tier],[data-mcd-remove]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-mcd-bound') === '1') continue;
      el.setAttribute('data-mcd-bound', '1');
      el.addEventListener('click', activate);
      el.addEventListener(
        'touchend',
        (function (node) {
          return function (e) {
            activate(e, node);
          };
        })(el),
        { passive: false }
      );
    }
  }

  bindDirect();

  // De lade wordt na elke wijziging opnieuw getekend; dan zijn de knoppen nieuwe elementen.
  var drawerRoot = document.getElementById('CartDrawer');
  if (drawerRoot && window.MutationObserver) {
    new MutationObserver(bindDirect).observe(drawerRoot, { childList: true, subtree: true });
  }
  document.addEventListener('cart:refresh', bindDirect);

  // Het geschenk hoort bij ELKE bestelling, niet alleen bij een bundel die via Kaching is toegevoegd.
  // Kaching voegt het toe binnen zijn eigen toevoegstroom; koopt iemand via het kaartenblok onderaan de
  // productpagina, dan gebeurt dat niet. ensureGift kijkt zelf of het al in de cart zit, dus hem hier ook
  // aanroepen is veilig - hij voegt nooit een tweede exemplaar toe.
  //
  // De vertraging is er omdat de cart pas na het antwoord van /cart/add.js klopt; de ontdubbeling voorkomt
  // dat een klik die zowel een submit als een click oplevert twee controles doet.
  var giftTimer = null;
  function planGiftControle() {
    if (giftTimer) clearTimeout(giftTimer);
    giftTimer = setTimeout(function () {
      giftTimer = null;
      ensureGift();
    }, 1500);
  }

  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) planGiftControle();
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('[data-card-submit], button[name="add"]')) planGiftControle();
    },
    true
  );
})();
